<template>
  <div>
    <div class="action-buttons">

      <!-- LEFT SIDE -->
      <div class="left-buttons" style="display: flex; align-items: center; gap: 20px; margin-top: 15px;">

        <!-- LOCATION -->
        <div class="form-group">
          <label>{{ $t('gestiune.locatie') }}</label>

          <select
            class="form-control"
            v-model="selectedLocation"
            :disabled="loading"
          >
            <option :value="null">Selectează</option>

            <optgroup
              v-for="group in groupedLocations"
              :key="group.vat"
              :label="`VAT: ${group.vat}`"
            >
              <option
                v-for="loc in group.locations"
                :key="loc.id"
                :value="loc"
              >
                {{ loc.name }}
              </option>
            </optgroup>
          </select>
        </div>

        <!-- DATE RANGE -->
        <div class="form-group" style="flex: 1; display: flex; flex-direction: column;">
          <label>Date și oră</label>

          <el-date-picker
            type="datetimerange"
            v-model="searchDate"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="w-100"
            :picker-options="pickerOptions"
            :disabled="loading"
          />
        </div>

      </div>

      <!-- RIGHT SIDE -->
      <div class="right-buttons" style="display: flex; gap: 10px;">

        <!-- XML -->
        <div class="search-button-reports pull-left">
          <div
            class="btn btn-icon btn-xls-slim"
            :title="'Export XML'"
            @click="exportSales('XML')"
          >
            {{ $t('gestiune.download_xml') }}
            <img src="/static/img/export_xls.png">
          </div>
        </div>

        <!-- XLS -->
        <div class="search-button-reports pull-left">
          <div
            class="btn btn-icon btn-xls-slim"
            :title="'Export XLS'"
            @click="exportSales('XLS')"
          >
            {{ $t('general.download_xls') }}
            <img src="/static/img/export_xls.png">
          </div>
        </div>

      </div>

    </div>

    <!-- INFO TEXT -->
    <div class="export-info-text">
      {{ $t('gestiune.exportAccountingSales.infoText') }}
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert2'

export default {
  props: {
    groupedLocations: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      loading: false,
      companyID: null,

      selectedLocation: null,
      searchDate: null,

      pickerOptions: {
        shortcuts: [
          {
            text: 'Astăzi',
            onClick (picker) {
              const start = new Date()
              start.setHours(0, 0, 0, 0)
              const end = new Date()
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Ieri',
            onClick (picker) {
              const start = new Date()
              start.setDate(start.getDate() - 1)
              start.setHours(0, 0, 0, 0)
              const end = new Date()
              end.setDate(end.getDate() - 1)
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Ultimele 7 zile',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setDate(end.getDate() - 6)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Ultimele 30 de zile',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setDate(end.getDate() - 29)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Luna curentă',
            onClick (picker) {
              const start = new Date()
              start.setDate(1)
              start.setHours(0, 0, 0, 0)
              const end = new Date()
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Luna trecută',
            onClick (picker) {
              const date = new Date()
              const start = new Date(date.getFullYear(), date.getMonth() - 1, 1)
              const end = new Date(date.getFullYear(), date.getMonth(), 0)
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Anul curent',
            onClick (picker) {
              const start = new Date(new Date().getFullYear(), 0, 1)
              const end = new Date()
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Anul trecut',
            onClick (picker) {
              const year = new Date().getFullYear() - 1
              const start = new Date(year, 0, 1)
              const end = new Date(year, 11, 31)
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick ({ maxDate, minDate }) {
          if (minDate && !maxDate) {
            minDate.setHours(0, 0, 0, 0)
          }
          if (maxDate) {
            maxDate.setHours(23, 59, 59, 999)
          }
        }
      }
    }
  },

  computed: {
    canExport () {
      return (
        this.selectedLocation &&
        this.searchDate &&
        this.searchDate.length === 2
      )
    }
  },

  created () {
    this.companyID = this.$session.get('selectedCompany')
  },

  methods: {
    async exportSales (format = 'XML') {
      try {
        if (!this.canExport) {
          swal({
            title: 'Atenție',
            text: 'Selectează locația și intervalul de date!',
            type: 'warning',
            timer: 2500,
            showConfirmButton: false
          })
          return
        }

        this.loading = true

        const startDate = new Date(this.searchDate[0]).toISOString()
        const endDate = new Date(this.searchDate[1]).toISOString()
        const externalLocationId = this.selectedLocation.true_id

        const url =
          `${process.env.API_BASE_URL_GESTIUNE}:4443/exports/accounting/vanzari` +
          `?startDate=${encodeURIComponent(startDate)}` +
          `&endDate=${encodeURIComponent(endDate)}` +
          `&externalLocationId=${encodeURIComponent(externalLocationId)}` +
          `&externalCompanyId=${encodeURIComponent(this.companyID)}` +
          `&export=${format}`

        window.location.href = url
      } catch (error) {
        console.error(error)

        swal({
          title: 'Eroare!',
          text: 'Nu s-a putut genera exportul.',
          type: 'error',
          timer: 3000,
          showConfirmButton: false
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.left-buttons {
  display: flex;
}

.right-buttons {
  display: flex;
  gap: 10px;
}

.form-group label {
  font-weight: 600;
  color: #25396F;
}

.export-info-text {
  margin-bottom: 20px;
  font-size: 13px;
  font-weight: 400;
  color: #25396F;
  background-color: #fff;
  padding: 10px 12px;
  border-radius: 8px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Accounting/AccountingSales.vue